export const teamDirectory = {
  contacts: [
    { name: 'Head of Design', role: 'Design Leadership', email: 'head-of-design@company.com', slack: '@head-design' },
    { name: 'UI Design Lead', role: 'UI Design Leadership', email: 'ui-design-lead@company.com', slack: '@ui-design-lead' },
    { name: 'UX Designer', role: 'User Experience', email: 'ux-designer@company.com', slack: '@ux-designer' },
    { name: 'Frontend Developer', role: 'Implementation Partner', email: 'frontend-dev@company.com', slack: '@frontend-dev' }
  ],
  mentors: [
    { name: 'Senior UI Designer Mentor', expertise: 'Visual Design & Interface Creation', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Design Systems Mentor', expertise: 'Component Libraries & Design Tokens', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Visual Design Mentor', expertise: 'Color, Typography & Visual Hierarchy', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'UX Design Team', contact: 'ux-team@company.com', purpose: 'User Experience & Interface Design Collaboration' },
    { team: 'Frontend Team', contact: 'frontend-team@company.com', purpose: 'UI Implementation & Technical Feasibility' },
    { team: 'Product Team', contact: 'product-team@company.com', purpose: 'Feature Requirements & UI Specifications' },
    { team: 'Brand Team', contact: 'brand-team@company.com', purpose: 'Brand Consistency & Visual Identity' }
  ],
  channels: {
    primary: '#ui-design',
    announcements: '#design-announcements',
    help: '#ui-design-help',
    systems: '#design-systems',
    critique: '#design-critique',
    implementation: '#ui-implementation',
    collaboration: '#design-dev-collab'
  }
};
